export default [
  {
    header: 'Who we are',
    content: 'HearMyRoar.org (a non-profit Benefit Corporation) is an online advocacy and micro-fundraising platform that galvanizes the collective voices of women (and their friends and families) into a “people’s lobby” for change. Founded by social entrepreneur and activist, Janice Weiss in 2018, HearMyRoar.org was inspired by our turbulent times and honors the 2020 anniversary of women winning the right to vote, working to ensure that all voices are heard and counted.',
  },
  {
    header: 'What we do',
    content: 'Partnering with cause organizations, we WAGE ROARS! that combine old-school printed postcards with proven storytelling tactics to pierce the heart of Congress and beyond. More impactful than a petition or an email, we unite the passion of hundreds of thousands of postcards into one big ROAR, mailed directly to seats of power across the nation, and tracked online for results.'
  },
  {
    header: 'Why we do it',
    content: `Our goal is to drive change and raise millions of dollars for women-inspired causes by crowdsourcing the voice of the people and turning it into a powerful force for community engagement, grassroots organizing, and productive problem resolution. We have committed 100% of all profits generated by HearMyRoar.org to these ends.
     One voice is a whisper.
    Thousands of voices joined together?
    THAT'S A ROAR!`
  }
];



// WEBPACK FOOTER //
// ./src/routes/static/About/meta.js